<template>
  <v-navigation-drawer
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage || ''"
    app
    id="core-navigation-drawer"
    mini-variant-width="80"
    mobile-break-point="960"
    v-bind="$attrs"
    v-model="drawer"
    width="260"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1"/>

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center "
          color="white"
          contain
        >
          <v-img
            :src="empresa != null ? empresa.logo || userImage : userImage"
            max-height="40"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="empresa != null ? empresa.nombre : ''"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2"/>

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>

      <template v-for="(item, i) in computedItems">
        <base-item-group
          :item="item"
          :key="`group-${i}`"
          v-if="item.children"
        >
          <!--  -->
        </base-item-group>

        <base-item
          :item="item"
          :key="`item-${i}`"
          v-else
        />
      </template>

      <div/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapActions, mapState } from 'vuex'
  import userImage from '@/assets/user.jpeg'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({
      userImage,
      items: [
        // {
        //   icon: 'mdi-view-dashboard',
        //   title: 'dashboard',
        //   to: '/',
        // },
        // {
        //   icon: 'mdi-account',
        //   title: 'user',
        //   to: '/pages/user',
        // },
        // {
        //   title: 'rtables',
        //   icon: 'mdi-clipboard-outline',
        //   to: '/tables/regular-tables',
        // },
        // {
        //   title: 'typography',
        //   icon: 'mdi-format-font',
        //   to: '/components/typography',
        // },
        // {
        //   title: 'icons',
        //   icon: 'mdi-chart-bubble',
        //   to: '/components/icons',
        // },
        // {
        //   title: 'google',
        //   icon: 'mdi-map-marker',
        //   to: '/maps/google-maps',
        // },
        // {
        //   title: 'notifications',
        //   icon: 'mdi-bell',
        //   to: '/components/notifications',
        // },
        {
          title: 'Dispositivos',
          icon: 'mdi-map-marker',
          to: '/dispositivos',
        },
        // {
        //   title: 'Dashboard',
        //   icon: 'mdi-view-dashboard',
        //   to: '/',
        // },
        {
          title: 'Alarmas',
          icon: 'mdi-bell',
          to: '/alarmas',
        },
        // {
        //   title: 'Perfil',
        //   icon: 'mdi-account',
        //   to: '/perfil',
        // },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage', 'appLoading', 'logo', 'user']),
      ...mapState('perfil', ['empresa']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        const title = this.user ? this.user.perfil.nombre : ''
        return {
          avatar: true,
          title,
        }
      },
    },
    methods: {
      ...mapActions('perfil', ['fetchEmpresa']),
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'
  .pointer
    cursor: pointer

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
